define('OutSystems/ClientRuntime/Transitions',["require", "exports", "./TransitionAnimation"], function (require, exports, TransitionAnimationModule) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.reverseTransition = exports.createTransition = exports.sanitizeTransition = exports.setDefaultTransition = exports.Default = exports.Transition = exports.TransitionAnimation = void 0;
    exports.TransitionAnimation = TransitionAnimationModule.TransitionAnimation;
    var Transition = (function () {
        function Transition(name) {
            if (name === void 0) { name = ""; }
            this.name = name;
        }
        return Transition;
    }());
    exports.Transition = Transition;
    var None = new Transition();
    var Fade = new Transition("fade");
    var SlideFromLeft = new Transition("slide-from-left");
    var SlideFromRight = new Transition("slide-from-right");
    var SlideFromBottom = new Transition("slide-from-bottom");
    var SlideFromTop = new Transition("slide-from-top");
    exports.Default = new Transition();
    function setDefaultTransition(transition) {
        exports.Default = transition;
    }
    exports.setDefaultTransition = setDefaultTransition;
    function sanitizeTransition(transition) {
        return new Transition(transition ? transition.name : "");
    }
    exports.sanitizeTransition = sanitizeTransition;
    function createTransition(transitionType, defaultTransition) {
        if (typeof transitionType === "string") {
            return new Transition(transitionType);
        }
        else {
            switch (transitionType) {
                case exports.TransitionAnimation.None:
                    return None;
                case exports.TransitionAnimation.Fade:
                    return Fade;
                case exports.TransitionAnimation.SlideFromLeft:
                    return SlideFromLeft;
                case exports.TransitionAnimation.SlideFromRight:
                    return SlideFromRight;
                case exports.TransitionAnimation.SlideFromBottom:
                    return SlideFromBottom;
                case exports.TransitionAnimation.SlideFromTop:
                    return SlideFromTop;
                case exports.TransitionAnimation.Default:
                    return exports.Default;
                default:
                    return defaultTransition;
            }
        }
    }
    exports.createTransition = createTransition;
    function reverseTransition(transition) {
        if (!transition || !transition.name) {
            return new Transition("");
        }
        switch (transition.name) {
            case Fade.name:
                return new Transition(Fade.name);
            case SlideFromBottom.name:
                return new Transition(SlideFromTop.name);
            case SlideFromLeft.name:
                return new Transition(SlideFromRight.name);
            case SlideFromRight.name:
                return new Transition(SlideFromLeft.name);
            case SlideFromTop.name:
                return new Transition(SlideFromBottom.name);
            default:
                return new Transition(transition.name + "-back");
        }
    }
    exports.reverseTransition = reverseTransition;
});
//# sourceMappingURL=Transitions.js.map;
